import { withCriteriaProvider } from './makeCriteriaProvider';
import useSearchableClientsWithHasMore from './useSearchableClients';

export const makeCriteriaProvider = (tag, context) =>
  withCriteriaProvider(tag, context, useSearchableClientsWithHasMore);
export { withCriteriaProvider } from './makeCriteriaProvider';
